import {isEmpty} from 'lodash'

const { atom } = require("recoil");

const persistEffect = key => ({ setSelf, onSet, trigger }) => {
  const loadPersisted = async () => {
    const savedValue = JSON.parse(localStorage.getItem(key))
    if (!isEmpty(savedValue)) {
      setSelf(savedValue)
    }
  }
  if (trigger === 'get') {
    loadPersisted()
  }
  onSet((newValue, _, isReset) => {
    isReset ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(newValue))
  })
}

const fingerprintState = atom({
  key: "fingerprintState",
  default: null,
  effects: [
    persistEffect('deviceUUID')
  ]
})

export {
  fingerprintState
}